/**
 * Labstep
 *
 * @module components/ProtocolTimer/Card
 * @desc ProtocolTimer Card
 */

import { ProtocolTimerActionMenu } from 'labstep-web/components/ProtocolTimer/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import { ProtocolTimerItemContainer } from 'labstep-web/containers/ProtocolTimer/Item';
import { ElementCard } from 'labstep-web/core/Card/Element';
import { Time } from 'labstep-web/core/Time';
import type React from 'react';
import type { IProtocolTimerCardProps } from './types';

export const ProtocolTimerCard: React.FC<IProtocolTimerCardProps> = ({
  protocolTimer,
  ...rest
}) => (
  <ElementCard
    dataCy="components/ProtocolTimer/Card"
    icon={ICONS.protocol.timer}
    name={protocolTimer.name}
    actions={
      <ProtocolTimerActionMenu
        protocolTimer={protocolTimer}
        actions={
          protocolTimer.is_experiment_child
            ? ['delete']
            : ['delete', 'edit']
        }
      />
    }
    right={
      protocolTimer.is_experiment_child ? (
        <ProtocolTimerItemContainer protocolTimer={protocolTimer}>
          {({ timeRemaining }) => <Time {...timeRemaining} />}
        </ProtocolTimerItemContainer>
      ) : null
    }
    {...rest}
  />
);
